import { Button, Grid } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import Header from "../Header/Header1";
import "./Support.scss";
import Box from "@mui/material/Box";
import WidgetsIcon from '@mui/icons-material/Widgets';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Avatar from '@mui/material/Avatar';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Stack from '@mui/material/Stack';
import './Support.scss'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Badge from '@mui/material/Badge';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Footer from "../Footer/footer";
import Loader from "../Loader";
import zec from "../../Img/profile-img-2.webp";
import profile from "../../Img/profile-img-1.webp";
import SearchIcon from '@mui/icons-material/Search';
import consts from "../../constant";
import usercalls from '../../Axios';
import { toast, Toaster } from "react-hot-toast";
import { UserDetails } from "../../Contexts/UserContext";
import { io } from "socket.io-client";

const socket = io(consts.socketUrl, {
  transports: ["websocket"],
  withCredentials: true
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "var(--support)",
  boxShadow: 24,
  p: 3,
  borderRadius: 2,
  '@media(max-width:575.98px)': {
    width: '80%'
  }
};

const Support = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const path = usercalls();

  const [chat, setChat] = useState([
    // { name: 'Sankar', noftify: 'Hi da How are you doing long time no see', img: profile, },
    // { name: 'Barath', noftify: 'Sankar Eod Podra', img: profile, },
    // { name: 'Priya', noftify: 'Saami Ac ah konjam kammi pannuda', img: zec },
    // { name: 'Gowtham', noftify: 'da figma unnaku send panniten', img: profile, },
    // { name: 'Lucky', noftify: 'Bharath kumar! inga vaa!!', img: profile, },
    // { name: 'Vignesh', noftify: 'Hi da How are you doing long time no see', img: profile, },
    // { name: 'Ramesh', noftify: 'Bro Dreamster Merge pannitingala', img: profile, },
    // { name: 'Arun', noftify: 'Hi da How are you doing long time no see', img: profile, },
  ])

  //personal chat

  const [perChat, setPerChat] = useState({});

  const { userData } = useContext(UserDetails);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [search, setSearch] = useState()

  const [message, setMessage] = useState([]);
  const [room, setRoom] = useState(null);

  const [updated, setUpdated] = useState('');

  const [movileView, setMovileView] = useState(false);

  const [ticket, setTicket] = useState({ title: "", reason: "" });

  const [activeBg, setActiveBg] = useState(0)

  // const chatEndRef = useRef(null);

  const chatAreaRef = useRef(null);

  // Scroll to bottom function
  const scrollToBottom = () => {
    const chatArea = chatAreaRef.current;
    if (chatArea) {
      chatArea.scrollTop = chatArea.scrollHeight;
    }
  };

  // Scroll to bottom when messages update
  useEffect(() => {
    scrollToBottom();
  }, [message, perChat, chat]);


  const handleTicketChange = (e) => {
    const { name, value } = e.target;
    setTicket(prev => ({ ...prev, [name]: value }))
  }


  const handleChangeSend = (event) => {
    setUpdated(event.target.value);

  };

  const handleEnterKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleClickSend();
    }
  };


  const handleClickSend = () => {
    // 👇 "message" stores input field value

    if (updated?.trim() !== '') {
      reply();
      setMessage([...message, { Reply: updated, role: 'user', createdAt: new Date() }])
      setUpdated('')
    }
  };

  const handleDeleteTodo = (index) => {
    const newTodos = [...message];
    newTodos.splice(index, 1);
    setMessage(newTodos);
  };

  //image upload

  const [imageUrl, setImageUrl] = useState(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    // console.log(reader, "result of file");

    reader.onloadend = () => {
      setImageUrl(reader.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleToggle = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleChatData = (val, ind) => {
    setRoom(val._id);
    socket.emit('join_support_room', room, "user");
    setPerChat({ ...val, ind });
    setMessage(val?.Answer);
    if (!isCollapsed && matches) {
      // handleToggle()
    } else {
      setMovileView(true)
    }

  }

  const getUserQuery = async (current) => {
    try {
      const url = `${consts.BackendUrl}/support/getmyqueries`;
      const response = await path.getCallWithToken({ url });
      const result = await response.json();
      if (result?.success) {
        setChat(result?.result);
        setPerChat(current ? { ...result.result[current], ind: current } : { ...result.result[0], ind: 0 })
        setRoom(result.result[0]._id)
        setMessage(current ? result.result[current]?.Answer : result.result[0]?.Answer)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const postQuery = async (current) => {
    try {
      const url = `${consts.BackendUrl}/support/addQuery`;
      const payload = { query: ticket }
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        // console.log(result.result)
        socket.emit("raise_ticket", result?.result);
        handleClose();
        // setChat([result?.result,...chat])
        getUserQuery();
        toast.success("Ticket created successfully.");
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      toast.error(error.message)
      console.log(error)
    }
  }

  const reply = async () => {
    try {
      const url = `${consts.BackendUrl}/support/reply`;
      const payload = { queryId: perChat?._id, reply: updated }
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        socket.emit("reply", { Reply: updated, room, user_id: { name: userData?.name }, role: 'user', createdAt: new Date() });
        // setChat([result?.result,...chat])
        // getUserQuery(perChat?.ind);
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      toast.error(error.message)
      console.log(error)
    }
  }

  useEffect(() => {
    getUserQuery()
  }, [])

  const formatTime = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    return `${hours}:${minutes} ${ampm}`;
  }

  useEffect(() => {
    socket.emit('join_support_room', room, "user");

    const handleReply = (data) => {
      if (data.room == room) {
        setMessage(prev => [...prev, data]);
      }
    };

    const handleTicketClose = (data) => {
      // console.log(data)
      if (data.room == room) {
        setPerChat(data);
      }
    };

    socket.on("receive_reply", handleReply);

    socket.on("receive_close_ticket", handleTicketClose)

    return () => {
      // socket.disconnect();
      socket.off('receive_reply', handleReply);
      socket.off('receive_close_ticket', handleTicketClose);
    }
  }, [room])

  const chatHistChat1 = (
    <div className='msglist'>
      <div className={(matches && isCollapsed) ? 'msg-lsit-head display-3' : 'msg-list-head display-2'}>
        <h3 className='chats cursor'>
          {/* [] */}
          {(matches && isCollapsed) ? <WidgetsIcon sx={{ fontSize: '25px !important', fill: '#7a7a7a' }} onClick={handleToggle} /> :
            "Chats"
          }
        </h3>
        <div className='msg-lsit-head-svg cursor'>
          <AddCircleIcon onClick={handleOpen} />
        </div>
        {(!isCollapsed && matches) ? <div className='msg-lsit-head-svg cursor'>
          <AddCircleIcon onClick={handleOpen} />

        </div> : <></>}
      </div>

      {
        !isCollapsed && <form class="form">
          <label for="search">
            <input class="inputs" type="text" required="" placeholder="Search twitter" id="search" />
            <div class="fancy-bg"></div>
            <div class="search">
              <SearchIcon />
            </div>

          </label>
        </form>
      }



      <div className='msg-list-area'>
        {chat.filter((obj) => {
          return (
            search?.toLocaleLowerCase() === undefined ? obj : obj.user_id?.name.toLocaleLowerCase().includes(search)
          )

        }).map((row, ind) => {
          return (

            <div className={ind === activeBg ? "display-2 mt-10 cursor active chat-ibox" : "display-2 mt-10 cursor  chat-ibox"} onClick={(() => { handleChatData(row, ind); setActiveBg(ind) })}>
              <div key={ind} className='msg-list-chat-main display-1 ' >
                <Badge
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  variant="dot"
                // className="online-bdg"
                >
                  <div>
                    <Avatar sx={{ width: 40, height: 40 }} alt="Remy Sharp" src={row.user_id?.profilePicture} />
                  </div>
                </Badge>
                <div className='msg-list-chat-name' >
                  {row.Query?.title}
                  <div className='chat-desc display-1' id='sentence' style={{ width: '100%' }}>
                    {(row.Query?.reason?.length > 30) ? row.Query?.reason.substring(0, 28) + '...' : row.Query?.reason}

                  </div>
                </div>
              </div>
              <div>


              </div>
            </div>
          )
        })}

      </div>
    </div >
  )



  const pvtChat1 = chat.length > 0 ? (
    <div className="msglist">


      <div className="colab-avatar-cont vr" >
        <Stack direction="row" spacing={-0.5}>
          {<div div className="cursor">
            {(!matches) ? <ArrowBackIosIcon sx={{ fontSize: '25px !important', fill: '#7a7a7a' }}
              onClick={(() => { movileView && setMovileView(false) })} /> : <></>}
          </div>}

        </Stack>
      </div>
      <div className="colab-chat-area msg" ref={chatAreaRef}>

        {message?.map((todo, ind) => <>
          {todo?.role == 'user' ? <div className="chat-area-inner-text user vr" key={ind}>
            <div>
              <Avatar sx={{ width: 30, height: 30 }} alt="Remy Sharp" src={perChat.user_id?.profilePicture} />
            </div>
            <div className="collab-send-text-main2 user">
              <div className="username">Me(dev)</div>
              <div className="txt1">{todo?.Reply}</div>
              <div className="time">{formatTime(new Date(todo?.createdAt))}</div>
            </div>
          </div>
            : (<div className="chat-area-inner-text vr" key={ind}>
              {/* <div>
            <Avatar sx={{ width: 30, height: 30 }} alt="Remy Sharp" src={perChat.img} />
          </div> */}
              <div className="collab-send-text-main">
                <div className="username">Admin</div>
                <div className="txt1">{todo?.Reply}</div>
                <div className="time">{formatTime(new Date(todo?.createdAt))}</div>
              </div>
            </div>)

          }

        </>)}
      </div>
      {perChat?.solved == false ? <div class="messageBox">
        {/* <div class="fileUploadWrapper">
          <label for="file">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 337 337">
              <circle
                stroke-width="20"
                stroke="#6c6c6c"
                fill="none"
                r="158.5"
                cy="168.5"
                cx="168.5"
              ></circle>
              <path
                stroke-linecap="round"
                stroke-width="25"
                stroke="#6c6c6c"
                d="M167.759 79V259"
              ></path>
              <path
                stroke-linecap="round"
                stroke-width="25"
                stroke="#6c6c6c"
                d="M79 167.138H259"
              ></path>
            </svg>
            <span class="tooltip">Add an image</span>
          </label>
          <input type="file" id="file" name="file" />
        </div> */}
        <input required="" placeholder="Message..." type="text" id="messageInput"
          value={updated}
          onChange={handleChangeSend}
          onKeyDown={handleEnterKeyPress}
        />
        <button id="sendButton" onClick={handleClickSend}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 664 663">
            <path
              fill="none"
              d="M646.293 331.888L17.7538 17.6187L155.245 331.888M646.293 331.888L17.753 646.157L155.245 331.888M646.293 331.888L318.735 330.228L155.245 331.888"
            ></path>
            <path
              stroke-linejoin="round"
              stroke-linecap="round"
              stroke-width="33.67"
              stroke="#6c6c6c"
              d="M646.293 331.888L17.7538 17.6187L155.245 331.888M646.293 331.888L17.753 646.157L155.245 331.888M646.293 331.888L318.735 330.228L155.245 331.888"
            ></path>
          </svg>
        </button>
      </div> : <p className="ticket-close">Ticket Closed</p>}




    </div>
  ) : (<div className="msglist" style={{ textAlign: "center" }}>
    <h2>No Chats</h2>
    <p>create ticket to start chat</p>
  </div>)


  return (
    <div className="support-full">
      <Grid container sx={{ justifyContent: "center" }}>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
          <Header />
          <Loader />
        </Grid>
        <Grid xs={12} sm={12} md={12} lg={12} xl={10}>
          <Grid container spacing={2} sx={{ justifyContent: 'center', marginTop: '20px' }} className="grid-responsive" >
            <Grid item xs={12} sm={12} md={6} lg={4} xl={3} className=" ">
              {(!matches && movileView) ? pvtChat1 : chatHistChat1}
            </Grid>
            {matches && <Grid item xs={12} sm={12} md={6} lg={8} xl={9} className=" ">
              {pvtChat1}
            </Grid>}


          </Grid>
        </Grid>

      </Grid >



      {/* ticket modal */}
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="close-icon new cursor">
            <HighlightOffIcon sx={{ fontSize: '30px' }} onClick={handleClose} />
          </div>
          <div className="create-ticket">
            <h2 style={{ color: 'var(--clr-font)' }}>Create Ticket</h2>
          </div>
          <div className="create-field">
            <div className="email-fill">
              <div className="email-name mod">
                Title
              </div>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                // label="Email Address"
                name="title"
                onChange={handleTicketChange}
                autoComplete="email"
                autoFocus
              />
            </div>
            <div className="email-fill mt-10">
              <div className="email-name mod">
                Reason
              </div>
              <TextField
                name="reason"
                onChange={handleTicketChange}
                id="outlined-multiline-static"
                margin="normal"
                fullWidth
                multiline
                rows={4}
              // defaultValue="Default Value"
              />
            </div>
            <div className="common-btn mt-20 text-center">
              <Button onClick={postQuery}>Submit</Button>
            </div>
          </div>
        </Box>
      </Modal>
      {/* ticket modal */}
      <Toaster />
      {/* <Footer /> */}
    </div >
  );
};

export default Support;
